import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AccessActions = createActionGroup({
    source: 'UserAccess',
    events: {
        load: props<{ payload: any }>(),
        reset: emptyProps()
    }
});
